import { FunctionComponent } from 'preact';
import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'preact/hooks';

import MoreButton from '../../../../../shared/MoreButton';
import joystickIcon from '../../../../../public/img/joystick.png';
import styles from './../../styles.module.scss';
// import { trackAmplitudeEvent } from '../../../../../shared/analytics';

import {
  selectGamesPromoActive,
  selectGamesPromo,
  stopPromotingGames,
  selectDrawAttentionToGames,
} from '../../slice';

import GamesPromo from './GamesPromo';

interface GameTileProps {
  item;
  onClickMore: () => void;
}

const getDifferenceInMins = (closedAt): number => {
  if (!closedAt) return null;
  const difference = Date.now() - closedAt;
  return Math.round(difference / 60000);
};

const GameTile: FunctionComponent<GameTileProps> = ({
  item,
  onClickMore,
}: GameTileProps) => {
  const dispatch = useDispatch();

  const [animate, setAnimate] = useState(false);
  const gamesPromoActive = useSelector(selectGamesPromoActive);
  const shouldDrawAttention = useSelector(selectDrawAttentionToGames);

  useEffect(() => {
    if (shouldDrawAttention) {
      setTimeout(() => setAnimate(shouldDrawAttention), 500);
    }
  }, [shouldDrawAttention]);

  const gamesPromo = useSelector(selectGamesPromo);

  const hideGamesPopover = (gamesClicked = false): void => {
    dispatch(stopPromotingGames({ now: Date.now(), gamesClicked }));
  };

  const onGamesClick = (): void => {
    // const timeDifference = getDifferenceInMins(gamesPromo.closedAt);

    // if (
    //   gamesPromoActive.active ||
    //   (timeDifference !== null && timeDifference <= 10)
    // ) {
    //   trackAmplitudeEvent(
    //     'Clicked on games while the message was shown or within 10 minutes after it was clicked away'
    //   );
    // }
    hideGamesPopover(true);
  };

  return (
    <div className={styles.gamesWrapper}>
      {gamesPromoActive.active && (
        <GamesPromo
          hideGamesPopover={() => hideGamesPopover()}
          animate={gamesPromoActive.fresh}
          enabledCounter={gamesPromo.enabledCounter}
        />
      )}

      <div className={`${styles.topPageContainer} `}>
        <MoreButton className={styles.moreButton} onClick={onClickMore} />
        <a
          href={`${process.env.APP_URL}/games`}
          className={styles.topPage}
          onClick={onGamesClick}
          onMouseEnter={(): void => setAnimate(true)}
          onMouseLeave={(): void => setAnimate(false)}
        >
          <div className={`${styles.icon} ${styles.joystickIcon}`}>
            <img
              src={joystickIcon}
              alt=""
              className={`${styles.joystickIcon} ${animate ? styles.animate : ''
                }`}
            />
          </div>
          <span className={styles.label}>{item.title}</span>
        </a>
      </div>
    </div>
  );
};

export default GameTile;
